class HeaderCart extends Component {
    constructor(el) {
        super(el);
        this.dropdown = this.$find('[data-dropdown]');
        this.opener = this.$find('[data-cart-opener]');
        this.priceHolder = this.$find('[data-price-holder]');
        this.addEventListeners();
    }

    toggleDropdown() {
        this.dropdown.classList.toggle('is-opened');
    }

    updateCartPrice({cartTotalPrice}) {
        this.priceHolder.innerHTML = cartTotalPrice;
    }

    addEventListeners() {
        this.dropdown && this.opener.addEventListener('click', () => this.toggleDropdown());
        EventBus.getInstance().addEventListener('cartUpdated', e => this.updateCartPrice(e.detail));
        document.addEventListener('click', e => {
            if (!this.$el.contains(e.target)) {
                this.dropdown.classList.remove('is-opened');
            }
        });
    }
}